/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Huboverviewdescription2Inputs */

const id_sandboxes_huboverviewdescription2 = /** @type {(inputs: Sandboxes_Huboverviewdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peta terfokus dari etalase, kepemilikan, pengiriman, dan catatan pembaruan untuk Namespace ini.`)
};

const ms_sandboxes_huboverviewdescription2 = /** @type {(inputs: Sandboxes_Huboverviewdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peta fokus kedai, pemilikan, penghantaran, dan rekod kemas kini untuk Namespace ini.`)
};

const da_sandboxes_huboverviewdescription2 = /** @type {(inputs: Sandboxes_Huboverviewdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Et fokuseret kort over butiksfacade, ejerskab, levering og opdateringsposter for dette Namespace.`)
};

const de_sandboxes_huboverviewdescription2 = /** @type {(inputs: Sandboxes_Huboverviewdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine fokussierte Karte der Storefront-, Besitz-, Liefer- und Aktualisierungsdatensätze für diesen Namespace.`)
};

const en_us2_sandboxes_huboverviewdescription2 = /** @type {(inputs: Sandboxes_Huboverviewdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A focused map of the storefront, ownership, delivery, and update records for this namespace.`)
};

const es_es2_sandboxes_huboverviewdescription2 = /** @type {(inputs: Sandboxes_Huboverviewdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un mapa enfocado de las entradas de la tienda, propiedad, entrega y registros de actualización para este Namespace.`)
};

const es_mx2_sandboxes_huboverviewdescription2 = /** @type {(inputs: Sandboxes_Huboverviewdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un mapa enfocado de las entradas de la tienda, propiedad, entrega y registros de actualización para este Namespace.`)
};

const fil_sandboxes_huboverviewdescription2 = /** @type {(inputs: Sandboxes_Huboverviewdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isang nakatuong mapa ng storefront, pagmamay-ari, paghahatid, at mga talaan ng update para sa Namespace na ito.`)
};

const fr_sandboxes_huboverviewdescription2 = /** @type {(inputs: Sandboxes_Huboverviewdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une carte ciblée des entrées de la vitrine, de la propriété, de la livraison et des enregistrements de mise à jour pour ce Namespace.`)
};

const it_sandboxes_huboverviewdescription2 = /** @type {(inputs: Sandboxes_Huboverviewdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una mappa concentrata del storefront, proprietà, consegna e registri di aggiornamento per questo Namespace.`)
};

const hu_sandboxes_huboverviewdescription2 = /** @type {(inputs: Sandboxes_Huboverviewdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A boltfront, tulajdonjog, kézbesítés és frissítési rekordok fókuszált térképe ehhez a Namespace-hez.`)
};

const nl_sandboxes_huboverviewdescription2 = /** @type {(inputs: Sandboxes_Huboverviewdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een gerichte kaart van de winkel, eigendom, levering en updaterecords voor deze Namespace.`)
};

const no_sandboxes_huboverviewdescription2 = /** @type {(inputs: Sandboxes_Huboverviewdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Et fokusert kart over butikkfronten, eierskap, levering og oppdateringsposter for dette Namespace.`)
};

const pl_sandboxes_huboverviewdescription2 = /** @type {(inputs: Sandboxes_Huboverviewdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skoncentrowana mapa wpisów sklepowych, własności, dostarczania i rekordów aktualizacji dla tego Namespace.`)
};

const pt_br2_sandboxes_huboverviewdescription2 = /** @type {(inputs: Sandboxes_Huboverviewdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um mapa focado das entradas da loja, propriedade, entrega e registros de atualização deste Namespace.`)
};

const pt_sandboxes_huboverviewdescription2 = /** @type {(inputs: Sandboxes_Huboverviewdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um mapa focado dos registos da loja, propriedade, entrega e atualizações para este Namespace.`)
};

const ro_sandboxes_huboverviewdescription2 = /** @type {(inputs: Sandboxes_Huboverviewdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O hartă focalizată a înregistrărilor din magazin, proprietate, livrare și actualizări pentru acest Namespace.`)
};

const fi_sandboxes_huboverviewdescription2 = /** @type {(inputs: Sandboxes_Huboverviewdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kohdennettu kartta kauppapaikan, omistuksen, toimituksen ja päivitystietueista tälle Namespacelle.`)
};

const sv_sandboxes_huboverviewdescription2 = /** @type {(inputs: Sandboxes_Huboverviewdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En fokuserad karta över butiks-, ägar-, leverans- och uppdateringsposter för detta namespace.`)
};

const vi_sandboxes_huboverviewdescription2 = /** @type {(inputs: Sandboxes_Huboverviewdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bản đồ tập trung về hồ sơ cửa hàng, quyền sở hữu, phân phối và cập nhật cho Namespace này.`)
};

const tr_sandboxes_huboverviewdescription2 = /** @type {(inputs: Sandboxes_Huboverviewdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu Namespace için mağaza ön yüzü, sahiplik, teslimat ve güncelleme kayıtlarının odaklanmış bir haritası.`)
};

const cs_sandboxes_huboverviewdescription2 = /** @type {(inputs: Sandboxes_Huboverviewdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaměřená mapa záznamů obchodu, vlastnictví, doručení a aktualizací pro tento Namespace.`)
};

const bg_sandboxes_huboverviewdescription2 = /** @type {(inputs: Sandboxes_Huboverviewdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фокусирана карта на записите за магазин, собственост, доставка и актуализации за този Namespace.`)
};

const ru_sandboxes_huboverviewdescription2 = /** @type {(inputs: Sandboxes_Huboverviewdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Карта подсвечивающая записи о витрине, о владении, об ассетах и обновлениях для этого пространства имён.`)
};

const uk_sandboxes_huboverviewdescription2 = /** @type {(inputs: Sandboxes_Huboverviewdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сфокусована карта записів магазину, власності, доставки та оновлень для цього Namespace.`)
};

const ar_sandboxes_huboverviewdescription2 = /** @type {(inputs: Sandboxes_Huboverviewdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خريطة مركزة لسجلات المتجر والملكية والتسليم والتحديثات لـ Namespace هذا.`)
};

const hi_sandboxes_huboverviewdescription2 = /** @type {(inputs: Sandboxes_Huboverviewdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस नेमस्पेस के लिए स्टोरफ्रंट, स्वामित्व, डिलीवरी और अपडेट रिकॉर्ड का एक केंद्रित मानचित्र।`)
};

const th_sandboxes_huboverviewdescription2 = /** @type {(inputs: Sandboxes_Huboverviewdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แผนที่รวมของบันทึกหน้าร้าน ความเป็นเจ้าของ การจัดส่ง และการอัปเดตสำหรับ Namespace นี้`)
};

const ja_sandboxes_huboverviewdescription2 = /** @type {(inputs: Sandboxes_Huboverviewdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この Namespace のストアフロント、所有権、配信、更新記録の焦点を絞ったマップ。`)
};

const zh_cn2_sandboxes_huboverviewdescription2 = /** @type {(inputs: Sandboxes_Huboverviewdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该命名空间的商店、拥有权、交付及更新记录的焦点视图。`)
};

const zh_hant1_sandboxes_huboverviewdescription2 = /** @type {(inputs: Sandboxes_Huboverviewdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`該命名空間的商店、擁有權、交付及更新記錄的焦點檢視。`)
};

const ko_sandboxes_huboverviewdescription2 = /** @type {(inputs: Sandboxes_Huboverviewdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 Namespace의 스토어프론트, 소유권, 전달 및 업데이트 레코드에 대한 집중 지도입니다.`)
};

/**
* | output |
* | --- |
* | "A focused map of the storefront, ownership, delivery, and update records for this namespace." |
*
* @param {Sandboxes_Huboverviewdescription2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_huboverviewdescription2 = /** @type {((inputs?: Sandboxes_Huboverviewdescription2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Huboverviewdescription2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_huboverviewdescription2(inputs)
	if (locale === "ms") return ms_sandboxes_huboverviewdescription2(inputs)
	if (locale === "da") return da_sandboxes_huboverviewdescription2(inputs)
	if (locale === "de") return de_sandboxes_huboverviewdescription2(inputs)
	if (locale === "en-US") return en_us2_sandboxes_huboverviewdescription2(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_huboverviewdescription2(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_huboverviewdescription2(inputs)
	if (locale === "fil") return fil_sandboxes_huboverviewdescription2(inputs)
	if (locale === "fr") return fr_sandboxes_huboverviewdescription2(inputs)
	if (locale === "it") return it_sandboxes_huboverviewdescription2(inputs)
	if (locale === "hu") return hu_sandboxes_huboverviewdescription2(inputs)
	if (locale === "nl") return nl_sandboxes_huboverviewdescription2(inputs)
	if (locale === "no") return no_sandboxes_huboverviewdescription2(inputs)
	if (locale === "pl") return pl_sandboxes_huboverviewdescription2(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_huboverviewdescription2(inputs)
	if (locale === "pt") return pt_sandboxes_huboverviewdescription2(inputs)
	if (locale === "ro") return ro_sandboxes_huboverviewdescription2(inputs)
	if (locale === "fi") return fi_sandboxes_huboverviewdescription2(inputs)
	if (locale === "sv") return sv_sandboxes_huboverviewdescription2(inputs)
	if (locale === "vi") return vi_sandboxes_huboverviewdescription2(inputs)
	if (locale === "tr") return tr_sandboxes_huboverviewdescription2(inputs)
	if (locale === "cs") return cs_sandboxes_huboverviewdescription2(inputs)
	if (locale === "bg") return bg_sandboxes_huboverviewdescription2(inputs)
	if (locale === "ru") return ru_sandboxes_huboverviewdescription2(inputs)
	if (locale === "uk") return uk_sandboxes_huboverviewdescription2(inputs)
	if (locale === "ar") return ar_sandboxes_huboverviewdescription2(inputs)
	if (locale === "hi") return hi_sandboxes_huboverviewdescription2(inputs)
	if (locale === "th") return th_sandboxes_huboverviewdescription2(inputs)
	if (locale === "ja") return ja_sandboxes_huboverviewdescription2(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_huboverviewdescription2(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_huboverviewdescription2(inputs)
	return ko_sandboxes_huboverviewdescription2(inputs)
});
export { sandboxes_huboverviewdescription2 as "sandboxes.hubOverviewDescription" }